// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';

import ThumbIcon from '../../../../assets/images/thumb-point.svg'

const S = {
  SeekBar: styled.div`
    height: 4px;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    border-radius: 4px;
    background: #FFFFFF;
    transition: height 0.1s, border-radius 0.1s;

    &:hover, &:hover > div {
      height: 10px;
      border-radius: 10px;
    }

    &:hover div > img {
      height: 24px;
      width: 24px;
    }
  `,
  Seek: styled.div<{ progress: number }>`
    height: 4px;
    width: ${props => props.progress * 100}%;
    cursor: pointer;
    background: #FCA032;
    position: relative;
    transition: height 0.1s, border-radius 0.1s;
    border-radius: 4px;
  `,
  SeekThumb: styled.img.attrs({ src: ThumbIcon, draggable: false })`
    width: 16px;
    height: 16px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
    transition: width 0.1s, height 0.1s;
  `,
}

export { S as default }
